module.exports = __webpack_public_path__ + "img/cover.f406da39.jpg";